import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { WebhookService } from 'src/app/core/services/webhook.service';
import { IEvent } from 'src/app/core/models/event.model';
import { IWebhook } from 'src/app/core/models/webhook.model';
import { TranslateService } from '@ngx-translate/core';

/**
 * @ignore
 */
@Component({
  selector: 'app-webhooks',
  templateUrl: './webhooks.component.html',
  styleUrls: ['./webhooks.component.css'],
})
export class WebhooksComponent implements OnInit {
  companyId: string;
  filials: any[];
  filial: any;
  toggleNewWebhook = false;
  currentUser: any;
  isLoading = false;
  company: any;

  events: IEvent[] = [];
  companyWebhooks: any;
  webhook = {} as IWebhook;
  webhookIsNew: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private webhookService: WebhookService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;

      if (this.currentUser.role.name === Role.USER) {
        this.companyId = this.currentUser.companyId;
      } else {
        this.route.parent.parent.params.subscribe((res) => {
          this.companyId = res.id || this.currentUser.companyId;
        });

        this.route.parent.parent.data.subscribe((res) => {
          this.company = res.company;
          this.breadcrumbService.set('@companyName', this.company.name);
        });
      }
      this.loadWebhooks();
      this.loadEvents();
    });
  }

  loadWebhooks() {
    this.webhookService.getCompanyWebhooks(this.companyId).subscribe(
      (res) => {
        this.companyWebhooks = res;
        console.log(this.companyWebhooks);
      },
      (err) => {
        this.companyWebhooks = [];
        this.toastr.error('Error loading companyWebhooks.');
      }
    );
  }

  loadEvents() {
    this.webhookService.getEvents().subscribe(
      (res) => {
        this.events = res;
        console.log(this.events);
      },
      (err) => {
        this.events = [];
        this.toastr.error('Error loading events.');
      }
    );
  }

  onAddWebhook() {
    this.webhook.baseUrl = '';
    this.webhook.eventId = null;
    this.webhookIsNew = true;
    this.toggleNewWebhook = true;
  }

  onEditWebhook(webhook: IWebhook) {
    this.webhook = JSON.parse(JSON.stringify(webhook));
    this.webhookIsNew = false;
    this.toggleNewWebhook = true;
  }

  onDeleteWebhook(webhook) {
    this.webhookService.deleteWebhook(this.companyId, webhook).subscribe(
      (res) => {
        this.toastr.success('Webhook deleted.');
        this.loadWebhooks();
      },
      (err) => {
        this.toastr.error('Error deleting webhook.');
      }
    );
  }

  addWebhook(form: NgForm) {
    console.log(form);
    console.log(this.webhook);
    this.webhookService.addWebhook(this.companyId, this.webhook).subscribe(
      (res) => {
        this.translate.get('webhhoks.webhookAdded').subscribe((res: string) => {
          this.toastr.success(res);
        });
        this.loadWebhooks();
        this.toggleNewWebhook = false;
      },
      (err) => {
        this.toastr.error('Error adding webhook.');
      }
    );
  }

  editWebhook(form: NgForm) {
    console.log(form);
    console.log(this.webhook);
    this.webhookService.editWebhook(this.companyId, this.webhook).subscribe(
      (res) => {
        this.translate
          .get('webhhoks.webhhoksEdited')
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        this.loadWebhooks();
        this.toggleNewWebhook = false;
      },
      (err) => {
        this.toastr.error('Error editing webhook.');
      }
    );
  }

  getEventName(eventId: string): string {
    let eventName = '';
    this.events.forEach((item) => {
      if (item.id == eventId) {
        eventName = item.name;
      }
    });

    return eventName;
  }
}
